import type { SpaceStatus } from '@repo/shared/orpc/procedures/spaces';
import type { ColorTokens } from '@repo/theme';
import { useTheme } from '@repo/theme';
import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

import { BaseTag } from './base-tag';

type TagConfig = {
    backgroundColor: string;
    emoji: string;
    label: TLabel;
};

function getTagConfig(colors: ColorTokens): Record<SpaceStatus, TagConfig> {
    return {
        active: {
            backgroundColor: colors.colorTagSuccess,
            emoji: '🚀',
            label: t('spaces.status_active', 'Active'),
        },
        draft: {
            backgroundColor: colors.colorTagAccentLight,
            emoji: '✍️',
            label: t('spaces.status_draft', 'Draft'),
        },
        closed: {
            backgroundColor: colors.colorTagHighlight,
            emoji: '🔒',
            label: t('spaces.status_closed', 'Closed'),
        },
    };
}

type SpaceStatusTagProps = {
    status: SpaceStatus;
};

export function SpaceStatusTag({ status }: SpaceStatusTagProps) {
    const { colors } = useTheme();
    const config = getTagConfig(colors)[status];
    return (
        <BaseTag
            backgroundColor={config.backgroundColor}
            color={colors.colorTextOnTagLight}
            label={config.label}
            prefix={config.emoji}
            type='small'
        />
    );
}
